import { render, staticRenderFns } from "./WelcomeModal.vue?vue&type=template&id=4172a31b&"
import script from "./WelcomeModal.vue?vue&type=script&lang=js&"
export * from "./WelcomeModal.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4172a31b')) {
      api.createRecord('4172a31b', component.options)
    } else {
      api.reload('4172a31b', component.options)
    }
    module.hot.accept("./WelcomeModal.vue?vue&type=template&id=4172a31b&", function () {
      api.rerender('4172a31b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WelcomeModal.vue"
export default component.exports